module.exports = __webpack_public_path__ + "img/1-7.c012d819.jpg";